import styled from '@emotion/styled'

export default styled.div`
  padding: 10px;
`
